// extracted by mini-css-extract-plugin
module.exports = {"container":"sign-up-form_container__vyzlx"};